(function() {
    $(() => {
        const $root = $('.blog-nav-wrapper .blog-nav-menu');
        setTimeout(() => {
            $(`.ghm-no-transition`).removeClass('ghm-no-transition');
        }, 500);

        const currenttag = $('[data-currenttag]').attr('data-currenttag');
        let $currentOption = $root.find(`.nav-item.nav-current`);
        if ($currentOption.length == 0) {
            $currentOption = $root.find(`.nav-item.nav-${currenttag}`);
            if ($currentOption.length == 0) $currentOption = $root.find(`.nav-item:first-child`);
            $currentOption.addClass('nav-current');
        }

        if (!$root.find('.value').length) {
            const label = $currentOption.text();
            $root.find('.m-select').append($(`
                <div class="value" tabindex="0">
                    <div class="value-span">${label}</div>
                </div>
                <input type="hidden" value="${label}" id="activeCategory" />
            `));
        }

        // const $navMore = $root.find('.blog-nav-menu-more');
        // const $navMoreText = $root.find('.nav-dropdown-button');
        // const $navMoreDropdown = $root.find('.blog-nav-menu-more .nav-dropdown-menu');

        // function updateNav() {
        //     const width = $nav.width();
        //     $navMore.css('opacity', 0);
            
        //     $navMoreDropdown.children().each((i, el) => {
        //         $nav.append(el);
        //     });

        //     let innerWidth = 0;
        //     innerWidth += $navMore.outerWidth(true);
            
        //     $nav.children(':not(.blog-nav-menu-more)').each((i, el) => {
        //         let w = $(el).outerWidth(true);
        //         innerWidth += w;
        //         if (innerWidth > width) {
        //             $navMoreDropdown.append(el);
        //             $navMore.css('opacity', 1);
        //         }
        //     });

        //     $navMoreText.text($nav.children().length > 1 ? 'More' : 'Menu');

        //     $nav.append($navMore);
        //     $root.css('overflow', 'visible');
        // }

        // updateNav();

        // const update = throttle(updateNav, 200);

        // $(window).on('resize', update);
    });
})();